import React, {Component} from 'react';
import i18 from '../../i18';
import {customerRuleApi} from '../../api';

class CustomerRules extends Component {
    getCompanyId = () => {
        return this.props.config.company_id;
    };

    onRemoveRule = async (rule) => {
        if (!window.confirm('Biztosan törölni szeretné a szabályt?')) {
            return;
        }

        try {
            const data = await customerRuleApi.remove(
                this.getCompanyId(),
                rule.id,
            );

            this.props.updateRules(data.customerRules);
            this.props.notifySuccess(
                'A szabály törlése sikeres.',
            );
        } catch (error) {
            this.props.notifyError(
                'A szabály törlése sikertelen.',
            );
        }
    };

    deleteAllRules = async () => {
        if (!window.confirm('Biztosan törölni szeretné az összes szabályt?')) {
            return;
        }

        try {
            const data = await customerRuleApi.removeAll(
                this.getCompanyId(),
            );

            this.props.updateRules(data.customerRules);
            this.props.notifySuccess(
                'Az összes szabály törlése sikeres.',
            );
        } catch (error) {
            this.props.notifyError(
                'A szabályok törlése sikertelen.',
            );
        }
    };

    renderRulesTableHeader = () => {
        return (
            <tr>
                <th>{i18.COMMON._identifier}</th>
                <th>{i18.CUSTOMER._typeOfTraffic}</th>
                <th>{i18.CUSTOMER._invoiceNumber}</th>
                <th>{i18.CUSTOMER._positionNumber}</th>
                <th>{i18.CUSTOMER._positionNumberCountry}</th>
                <th>{i18.CUSTOMER._orderNumberStat}</th>
                <th>{i18.CUSTOMER._mainBookNumber}</th>
                <th>{i18.CUSTOMER._VAT}</th>
                <th>{i18.CUSTOMER._collectorCode}</th>
                <th>{i18.CUSTOMER._taxNumber}</th>
                <th>{i18.CUSTOMER._vatDegreeNumber}</th>
                <th>{i18.COMMON._typeOfRule}</th>
                <th>{i18.COMMON._position}</th>
                <th>{i18.COMMON._updatedAt}</th>
                <th style={{width: '70px'}}/>
            </tr>
        );
    };

    renderRulesTableRow = (rule) => {
        return (
            <tr key={`customer-rule-${rule.id}`}>
                <td>#{rule.id}</td>
                <td>{rule.item_name || '-'}</td>
                <td>{rule.invoice_number || '-'}</td>
                <td>{rule.position_number || '-'}</td>
                <td>{rule.position_number_country || '-'}</td>
                <td>{rule.order_number_stat || '-'}</td>
                <td>{rule.main_bookkeeping_number}</td>
                <td>{rule.vat}%</td>
                <td>{rule.vat_collector_code}</td>
                <td>{rule.company_type_label}</td>
                <td>{rule.vat_degree}</td>
                <td>{rule.type_label}</td>
                <td>{rule.position}</td>
                <td>{rule.updated_at}</td>
                <td>
                    <i
                        onClick={() => this.props.editRule(rule)}
                        title={i18.CUSTOMER._editRule}
                        className="fa fa-pencil-square-o"
                        aria-hidden="true"
                    />

                    &nbsp;&nbsp;

                    <i
                        onClick={() => this.onRemoveRule(rule)}
                        title={i18.CUSTOMER._deleteRule}
                        className="fa fa-trash-o"
                        aria-hidden="true"
                    />
                </td>
            </tr>
        );
    };

    render() {
        const {
            customerRules,
            toggleRulesPage,
        } = this.props;

        return (
            <section id="customer-rules">
                <div className="header">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1>
                                    <a
                                        onClick={toggleRulesPage}
                                        className="choose-btn"
                                    >
                                        {i18.BUTTONS._back}
                                    </a>

                                    {i18.CUSTOMER._rulesTitle}
                                </h1>
                            </div>

                            <div className="col-12">
                                <p>
                                    {i18.CUSTOMER._rulesDescription}
                                </p>

                                <a
                                    className="link-color"
                                    onClick={this.deleteAllRules}
                                >
                                    <i className="fa fa-trash-o" aria-hidden="true"/>&nbsp;{i18.COMMON._deleteAllRules}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <table className="table table-striped table-aibook-no-border table-hover cursor-pointer">
                                    <thead>
                                    {this.renderRulesTableHeader()}
                                    </thead>
                                    <tbody>
                                    {customerRules.map(
                                        this.renderRulesTableRow,
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default CustomerRules;


// WEBPACK FOOTER //
// ./src/components/customer/CustomerRules.js